<template>
  <div class="registered">
    <div class="form-registered">
      <!-- log -->
      <div class="form-registered-log">
        <img src="../../assets/image/login/login-logo.png" />
      </div>
      <!-- 注册 -->
      <div class="form-registered-center">
        <div class="form-registered-mask">
          <img src="../../assets/image/login/registered-MASK.png" />
          <div class="form-registered-mask-size">
            <div><img src="../../assets/image/login/zhu.png"></div>
            <div style="margin-top: 53px">
              <img src="../../assets/image/login/ce.png">
            </div>
          </div>
        </div>
        <!-- 右侧注册 -->
        <div class="form-registered-content">
          <div class="form-registered-top-bgc">
            <img src="../../assets/image/login/top-bgc.png" />
          </div>
          <!-- 内容区 -->
          <div class="class-registered">
            <div class="class-registered-text">根据您的工作职责选择对应的身份进行注册</div>
            <!-- 注册账号密码 -->
            <div class="phone-password">
              <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
                label-position="top"
              >
                <div class="form-content-flex">
                  <!-- 手机号外侧盒子 -->
                  <div class="form-content-flex-item">
                    <div class="form-content-flex-item-left">
                      <el-form-item
                        label="手机号"
                        prop="phone"
                      >
                        <el-input
                          type="text"
                          v-model="ruleForm.phone"
                          autocomplete="off"
                          clearable
                          placeholder="请输入手机号"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="form-content-flex-item-right"></div>
                  </div>
                  <!-- 密码外侧盒子 -->
                  <div class="form-content-flex-item">
                    <div class="form-content-flex-item-left">
                      <el-form-item
                        label="密码"
                        prop="password"
                        class="add-password"
                      >
                        <el-input
                          type="password"
                          v-model="ruleForm.password"
                          autocomplete="off"
                          clearable
                          show-password
                          placeholder="请输入密码"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="form-content-flex-item-right">
                      <el-form-item
                        label="确认密码"
                        prop="repwd"
                      >
                        <el-input
                          type="password"
                          v-model="ruleForm.repwd"
                          autocomplete="off"
                          clearable
                          show-password
                          placeholder="请输入确认密码"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <!-- 验证码外侧盒子 -->
                  <div class="form-content-flex-item">
                    <div class="form-content-flex-item-left">
                      <el-form-item
                        label="验证码"
                        prop="code"
                        class="add-password"
                      >
                        <el-input
                          type="text"
                          v-model="ruleForm.code"
                          autocomplete="off"
                          clearable
                          placeholder="请输入验证码"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="form-content-flex-item-right-btn">
                      <get-code
                        :ruleForm="ruleForm"
                        :type="'REG'"
                      />
                    </div>
                  </div>

                  <!-- 选择职业盒子 -->
                  <div class="form-content-flex-item">
                    <div class="form-content-flex-item-left">
                      <el-form-item prop="userTypeId">
                        <el-select
                          v-model="ruleForm.userTypeId"
                          placeholder="请选择职业"
                          style="width: 230px;"
                        >
                          <el-option
                            v-for="item in OccupationList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="form-content-flex-item-right"></div>
                  </div>
                </div>
                <!-- 登录 -->
                <div class="submit">
                  <el-button
                    @click="submitForm('ruleForm')"
                    style="background: #484c7f; color: #fff; width: 315px;"
                    v-prevent="3000"
                  >注册</el-button>
                </div>
              </el-form>
            </div>
          </div>
          <!-- 底部背景图 -->
          <div class="buttom-img">
            <img src="../../assets/image/login/buttom-bgcd.png">
          </div>
        </div>
        <!-- 内容区结束 -->
      </div>
    </div>
    <!-- 底部 -->
    <div class="form-login-text">
      Copyright 2013 - 2020 凯斯通. All rights reserved
      备案号：京ICP备2021013735号-1
    </div>
  </div>
</template>

<script>
import getCode from '../../components/getCode/index.vue'
export default {
  name: 'registered',
  components: {
    getCode
  },
  data () {
    //手机
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        callback()
      }
    }
    //密码
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    //确认密码
    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    //验证码
    var validatePass4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    //请选择职业
    var validatePass5 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择职业'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        phone: '',
        password: '',
        repwd: '',
        code: "",
        userTypeId: '',
        team_id: "",
        project_id: "",
        invite_id: "",
      },
      rules: {
        phone: [{ validator: validatePass, trigger: 'blur' }],
        password: [{ validator: validatePass2, trigger: 'blur' }],
        repwd: [{ validator: validatePass3, trigger: 'blur' }],
        code: [{ validator: validatePass4, trigger: 'blur' }],
        userTypeId: [{ validator: validatePass5, trigger: 'change' }],
      },
      OccupationList: []
    }
  },
  mounted () {
    this.getOccupation()
  },
  methods: {
    //提交 
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.registered()
        } else {
          return false;
        }
      });
    },
    //注册 
    async registered () {
      const { data: data } = await this.$http.post('login/reg', this.ruleForm)
      this.$router.push('/login')
      this.$message({
        message: data.message,
        type: 'success',
      });
    },
    //职业
    async getOccupation () {
      const { data: data } = await this.$http.get('user/type')
      this.OccupationList = data.data
    }
  }
}
</script>

<style lang="less" scoped>
.registered {
  width: 100%;
  height: 100%;
  background: url(../../assets/image/login/bgc.png) no-repeat center;
  .form-registered {
    width: 100%;
    height: 100%;
    padding: 22px 38px;

    .form-registered-log {
      width: 228px;
      height: 65px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .form-registered-center {
      width: 1120px;
      height: 645px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.16);
      display: flex;
      // 左侧蒙版
      .form-registered-mask {
        position: relative;
        width: 350px;
        height: 645px;
        img {
          width: 100%;
          height: 100%;
        }
        .form-registered-mask-size {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      // 右侧注册
      .form-registered-content {
        position: relative;
        flex: 1;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        .form-registered-top-bgc {
          position: absolute;
          top: 0;
          right: 0;
          width: 82px;
          height: 50px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        //内容区
        .class-registered {
          .class-registered-text {
            margin-top: 105px;
            font-size: 13px;
            color: #212529;
            // font-weight: 600;
            text-align: center;
          }
          .phone-password {
            position: relative;
            margin-top: 55px;
            z-index: 9999;

            .form-content-flex {
              width: 550px;
              .form-content-flex-item {
                position: relative;
                width: 100%;
                margin-bottom: 25px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .form-content-flex-item-left {
                  width: 230px;
                }
                .form-content-flex-item-right {
                  width: 230px;
                }
                .form-content-flex-item-right-btn {
                  position: relative;
                  top: 10px;
                  right: 165px;
                }
              }

              // & /deep/ .el-form-item__content {
              //   line-height: 40px;
              // }
              // & /deep/ .el-input__inner {
              //   height: 40px;
              // }
            }

            .submit {
              margin-top: 45px;
              text-align: center;
            }
          }
          //修改 ement 样式
          & /deep/ .el-form-item {
            margin-bottom: 5px;
          }
          & /deep/ .el-form-item__label {
            line-height: 0 !important;
          }
          & /deep/ .el-form-item__content .el-input .el-input__inner {
            border-top: 0px;
            border-left: 0px;
            border-right: 0px;
            border-radius: 0px;
            padding: 0;
          }
        }
        .buttom-img {
          position: absolute;
          left: 0;
          bottom: 5px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .form-login-text {
    position: absolute;
    top: 87.3%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    color: #909399;
  }
}
</style>